export const TimersConst = {
  SEARCH_FIELD_DEBOUNCE_TIME: 750,
  TABLE_RESIZE_DEBOUNCE_TIME: 750,
  REQUEST_INTERVAL_TIME: 2000,
  OPENING_LOADER_TIME: 500,
};
